'use client';
import * as Styled from './styled';
import { IRepository } from '@/types';
import { Row } from '@/ui/primatives';
import Tag from '@/ui/Tag';
import Button from '@/ui/Button';
import { IEvaluation } from '@/lib/evaluationsApi';
import { estimatedRunCost, getApproximateCost } from '../lib';
import pluralize from 'pluralize';
import * as EvaluationTag from '../EvaluationTag';
import { cancelEvaluationItem } from '@/serverActions/cancelEvaluationAction';

type RunStatusProps = {
  repository: IRepository;
  evaluation: IEvaluation;
  rowCount?: number;
  children?: React.ReactNode;
};

const RunStatus: React.FC<RunStatusProps> = ({ repository, evaluation, rowCount, children }) => {
  const { tokens_used: tokensUsed, status, progress } = evaluation;

  const isRunning = !!tokensUsed && !!rowCount && status === 'started';
  const isCompletedSample = !!rowCount && evaluation.is_sample && status === 'completed';

  const onCancel = () => {
    if (window.confirm('Are you sure you want to cancel this evaluation run?')) {
      cancelEvaluationItem(repository, evaluation.id);
    }
  };

  return (
    <Styled.RunStatus>
      <Row gap={10} alignItems="center">
        <div>
          {pluralize('row', progress.processed, true)} processed
          {!!tokensUsed && (
            <span>
              , {pluralize('token', tokensUsed, true)} used{' '}
              {evaluation.credits_used && <span>(${getApproximateCost(evaluation)})</span>}
            </span>
          )}
        </div>

        {(isRunning || isCompletedSample) && evaluation.credits_used && (
          <Tag variant="info">
            Estimated cost for all {rowCount} rows: ${estimatedRunCost(evaluation, rowCount)}
          </Tag>
        )}
      </Row>
      <Row gap={10} alignItems="center">
        {children}
        {status && <EvaluationTag.Status evaluation={evaluation} />}
        {isRunning && (
          <Button.Basic className="danger" tiny onClick={onCancel}>
            Stop
          </Button.Basic>
        )}
      </Row>
    </Styled.RunStatus>
  );
};

export default RunStatus;
